"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Metadata for a time series event
 */
var EventMetadataImpl = /** @class */ (function () {
    /**
     * Create a new EventMetadataImpl instance
     *
     * @param  sequence   the event sequence number
     * @param  timestamp  the event timestamp
     * @param  author     the event author
     */
    function EventMetadataImpl(sequence, timestamp, author) {
        this.sequence = sequence;
        this.timestamp = timestamp;
        this.author = author;
    }
    /**
     * Check if the EventMetadataImpl is equal to another object
     *
     * @param  other the other object
     * @return       `true` if the other object is a EventMetadataImpl and is equal
     */
    EventMetadataImpl.prototype.equals = function (other) {
        if (other && other instanceof EventMetadataImpl) {
            return this.sequence === other.sequence &&
                this.timestamp === other.timestamp &&
                this.author === other.author;
        }
        return false;
    };
    return EventMetadataImpl;
}());
exports.EventMetadataImpl = EventMetadataImpl;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/timeseries/time-series-event-metadata.js
// module id = 555
// module chunks = 1